
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Users } from 'lucide-react';
import { CRMUser } from '@/types/crm';
import CRMUsersTable from '../CRMUsersTable';
import CRMUserDetail from '../CRMUserDetail';
import CRMSearchBar from '../CRMSearchBar';

interface CRMUsersPanelProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  filteredUsers: CRMUser[];
  newUsers: CRMUser[];
  contactedUsers: CRMUser[];
  activeUsers: CRMUser[];
  selectedUser: CRMUser | null;
  onViewUser: (user: CRMUser) => void;
  onSendReferral: (userId: string) => void;
  processingUsers: string[];
  onBackToList: () => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const CRMUsersPanel: React.FC<CRMUsersPanelProps> = ({
  activeTab,
  setActiveTab,
  filteredUsers,
  newUsers,
  contactedUsers,
  activeUsers,
  selectedUser,
  onViewUser,
  onSendReferral,
  processingUsers,
  onBackToList,
  searchQuery,
  setSearchQuery,
}) => {
  if (selectedUser) {
    return (
      <CRMUserDetail
        user={selectedUser}
        onBack={onBackToList}
        onSendReferral={onSendReferral}
        isProcessing={processingUsers.includes(selectedUser.id)}
      />
    );
  }

  return (
    <>
      <div className="mb-6">
        <CRMSearchBar 
          searchQuery={searchQuery} 
          setSearchQuery={setSearchQuery} 
        />
      </div>
      
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="all" className="flex gap-1">
            <Users className="h-4 w-4" />
            All ({filteredUsers.length})
          </TabsTrigger>
          <TabsTrigger value="new">
            New ({newUsers.length})
          </TabsTrigger>
          <TabsTrigger value="contacted">
            Contacted ({contactedUsers.length})
          </TabsTrigger>
          <TabsTrigger value="active">
            Active ({activeUsers.length})
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="all">
          <CRMUsersTable 
            users={filteredUsers}
            onViewUser={onViewUser}
            onSendReferral={onSendReferral}
            processingUsers={processingUsers}
          />
        </TabsContent>
        
        <TabsContent value="new">
          <CRMUsersTable 
            users={newUsers}
            onViewUser={onViewUser}
            onSendReferral={onSendReferral}
            processingUsers={processingUsers}
          />
        </TabsContent>
        
        <TabsContent value="contacted">
          <CRMUsersTable 
            users={contactedUsers}
            onViewUser={onViewUser}
            onSendReferral={onSendReferral}
            processingUsers={processingUsers}
          />
        </TabsContent>
        
        <TabsContent value="active">
          <CRMUsersTable 
            users={activeUsers}
            onViewUser={onViewUser}
            onSendReferral={onSendReferral}
            processingUsers={processingUsers}
          />
        </TabsContent>
      </Tabs>
    </>
  );
};

export default CRMUsersPanel;

